import { NgModule, Component, OnInit } from '@angular/core';

import { UserService, CommonService } from '../../_services';
interface AccessibleMenuItem {
	menu: boolean;
	[key: string]: any; // optionally include other properties
}
@Component({
	selector: 'app-sidebar',
	templateUrl: './app-sidebar.component.html',
	styleUrls: ['./app-sidebar.component.scss']
})

export class AppSidebarComponent implements OnInit {
	menu: { isMini: boolean } = { isMini: false };
	isSubmenuActive = false;
	userType = '';
	accessibleMenu: AccessibleMenuItem[] = [];
	showDahsboard = true;
	constructor(private commonService: CommonService, private userService: UserService) {
		const userData = this.userService.getUserInfo();
		if (userData.role === "viber_analytics") {
			this.commonService.showDashboard = false;
		} else {
			this.commonService.showDashboard = true;
		}
		this.showDahsboard = this.commonService.showDashboard;
	}

	ngOnInit() {
		this.menu = this.commonService.menu;
		this.accessibleMenu = this.commonService.isMenuAccessible();
		//this.userType = this.userService.getUserInfo().type.toLocaleLowerCase();
	}
	subMenuToggle(i: any) {
		this.accessibleMenu.forEach((menu, index) => {
			if (index !== i) {
				menu.menu = false;
			}
		});
		this.accessibleMenu[i].menu = !this.accessibleMenu[i].menu;
	}
}